import {
  GridColDef,
  GridColumnHeaderParams,
  GridRenderCellParams,
} from '@mui/x-data-grid';
import {t} from 'i18next';
import ArrButton from '../../common/arr-button/ArrButton';
import {Box} from '@mui/material';
export const keywordListColumns = (
  handleDelete: (selectedData: GridRenderCellParams) => void,
  handleEdit: (selectedData: GridRenderCellParams) => void
) => {
  return [
    {
      field: 'groupName',
      headerName: t('keywordHighlighting.gridColumn.keywordName'),
      flex: 1.5,
      renderHeader: (param: GridColumnHeaderParams) => (
        <div
          tabIndex={0}
          role="rowheader"
          className="table_header"
          data-testid={`keyword-highlight-list-group-name-column`}
        >
          {param.colDef.headerName}
        </div>
      ),
      renderCell: (params) => (
        <span
          tabIndex={0}
          aria-label={params.value}
          role="gridcell"
          className="cell-label table_cells"
          data-testid={`keyword-highlight-list-group-name-${params.id}`}
        >
          {params.value}
        </span>
      ),
    },
    {
      field: 'color',
      headerName: t('keywordHighlighting.gridColumn.color'),
      flex: 1.5,
      renderHeader: (param: GridColumnHeaderParams) => (
        <div
          tabIndex={0}
          role="rowheader"
          className="table_header"
          data-testid={`keyword-highlight-list-columns-color-header`}
        >
          {param.colDef.headerName}
        </div>
      ),
      renderCell: (params: any) => (
        <div
          role="gridcell"
          className="keyword-grid-color-cell table_cells"
          tabIndex={0}
          data-testid={`keyword-highlight-list-columns-color-${params.id}`}
        >
          <div
            className="color-dot"
            data-testid="color-dot"
            style={{
              backgroundColor: `#${params.row.colorTypeRGB || 'ffffff'}`,
            }}
          />
          <span data-testid="color-code">{params.row.colorCode}</span>
        </div>
      ),
    },
    {
      field: 'description',
      headerName: t('keywordHighlighting.gridColumn.des'),
      flex: 2,
      renderHeader: (param: GridColumnHeaderParams) => (
        <div
          tabIndex={0}
          role="rowheader"
          className="table_header"
          data-testid={`keyword-highlight-list-columns-desctiption`}
        >
          {param.colDef.headerName}
        </div>
      ),
      renderCell: (params) => (
        <span
          tabIndex={0}
          className="cell-label table_cells"
          data-testid={`keyword-highlight-list-columns-${params.id}`}
        >
          {params.value}
        </span>
      ),
    },
    {
      field: 'keywords',
      headerName: t('keywordHighlighting.gridColumn.keywords'),
      flex: 2,
      renderHeader: (param: GridColumnHeaderParams) => (
        <div
          tabIndex={0}
          role="rowheader"
          className="table_header"
          data-testid={`keyword-highlight-list-columns-keywords-header`}
        >
          {param.colDef.headerName}
        </div>
      ),
      renderCell: (params) => (
        <span
          tabIndex={0}
          className="cell-label table_cells"
          data-testid={`keyword-highlight-list-keywords-${params.id}`}
        >
          {params.value}
        </span>
      ),
    },
    {
      field: 'actions',
      headerName: t('keywordHighlighting.gridColumn.actions'),
      sortable: false,
      filterable: false,
      flex: 2,
      headerClassName: 'typo-text label2_size more-option-header',
      renderHeader: (param: GridColumnHeaderParams) => (
        <div
          tabIndex={0}
          role="rowheader"
          className="table_header"
          data-testid={`keyword-highlight-list-actions-header`}
        >
          {param.colDef.headerName}
        </div>
      ),
      renderCell: (params: GridRenderCellParams) => (
        <Box
          className="grid-actions"
          data-testid={`actions-cell-wrapper-${params.id}`}
        >
          <ArrButton
            variant="secondary"
            tabIndex={0}
            dataTestId={`edit-actions-${params.id}`}
            size="xs"
            onClick={() => {
              handleEdit(params.row);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.code === 'Space') {
                e.stopPropagation();
                handleEdit(params.row);
              }
            }}
          >
            {t('common.edit')}
          </ArrButton>
          <ArrButton
            tabIndex={0}
            variant="secondary"
            dataTestId={`delete-keyword-highlight-${params.id}`}
            size="xs"
            onClick={() => {
              handleDelete(params.row);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.code === 'Space') {
                e.stopPropagation();
                handleDelete(params.row);
              }
            }}
          >
            {t('common.delete')}
          </ArrButton>
        </Box>
      ),
      cellClassName: 'action-cell',
    },
  ];
};
